function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.7487 0.719727C20.9447 0.719727 26.7767 6.55173 26.7767 13.7477C26.7767 16.9957 25.5807 19.9577 23.6167 22.2397L31.4447 30.0677L30.0307 31.4817L22.2007 23.6517C19.9247 25.5957 16.9767 26.7757 13.7507 26.7757C6.5547 26.7757 0.720703 20.9437 0.720703 13.7477C0.720703 6.55173 6.5547 0.719727 13.7487 0.719727ZM13.7487 2.71973C10.8027 2.71973 8.0327 3.86773 5.9507 5.94973C3.8687 8.03373 2.7207 10.8017 2.7207 13.7477C2.7207 19.8277 7.6687 24.7757 13.7507 24.7757C16.6947 24.7757 19.4647 23.6277 21.5487 21.5457C23.6307 19.4617 24.7767 16.6937 24.7767 13.7477C24.7767 7.66773 19.8307 2.71973 13.7487 2.71973Z",
  fill: "currentColor"
});

var SvgMagnifierIcon = function SvgMagnifierIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMagnifierIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/MagnifierIcon.e87c23b8.svg";
export { ForwardRef as ReactComponent };